// extracted by mini-css-extract-plugin
export var checkbox = "Checkbox-module--checkbox--06957";
export var checkmark = "Checkbox-module--checkmark--893ba";
export var label = "Checkbox-module--label--ff203";